import { Form, message } from 'antd';
import { Modal } from 'components';
import { ExpensesReportInfoFormItems } from 'features/expenses-report/component/modal/reportExpensesitem';
import { useCreateExpenses } from 'features/expenses-report/use-cases/create-expenses';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { useState } from 'react';
export const EditReportExpensesModal = ({
  onClose,
  editdata,
}: {
  onClose: () => void;
  editdata: any;
}) => {
  const [form] = Form.useForm();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const formName = 'edit-user-form';
  const { isLoading, mutate } = useCreateExpenses();

  const handleUpdate = (values: any) => {
    const payload: any = {
      Id: editdata?.Id,
      FacilityId: editdata?.facility_id,
      FieldId: editdata.field_id,
      SportsId: editdata?.sports_id,
      Jan: Number(values.jan || 0),
      Feb: Number(values.feb || 0),
      Mar: Number(values.mar || 0),
      Apr: Number(values.apr || 0),
      May: Number(values.may || 0),
      Jun: Number(values.jun || 0),
      Jul: Number(values.jul || 0),
      Aug: Number(values.aug || 0),
      Sep: Number(values.sep || 0),
      Oct: Number(values.oct || 0),
      Nov: Number(values.nov || 0),
      Dec: Number(values.dec || 0),
    };

    mutate(payload, {
      onSuccess: (data: any) => {
        form.resetFields();
        message.success(data?.ResponseMessage);
        onClose();
      },
    });
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        className='right-modal cstmmdlright'
        title={'Update Charge'}
        onCancel={() => {
          onClose(); // Call onClose function
        }}
        getContainer={false}
        onOk={form.submit}
        okText={'Update Charge'}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{
          form: formName,
          loading: isLoading,
        }}
      >
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          onFinish={handleUpdate}
        >
          <ExpensesReportInfoFormItems form={form} editdata={editdata} />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
